import { VITE_ENV_REVIEW } from '@/app/data/general_constants';
import { PROFILE_TYPES, RECORD_TYPE } from '@/app/data/model_constants';

function zigguSubdomainURL(subdomain, path = '') {
  // suffix consists of TLD and possibly port (if non-default)
  const suffix = window.location.origin.split('.').pop();
  // prefix only for review env based on merge request id
  const prefix =
    import.meta.env.VITE_ENV === VITE_ENV_REVIEW && !import.meta.env.IS_LOCAL
      ? `${import.meta.env.VITE_PULL_REQUEST_VM_IDX}.`
      : '';
  return `https://${subdomain}.${prefix}ziggu.${suffix}${path}`;
}

function zigguProfileSubdomain(profile, tenant) {
  let subdomain;
  if (profile.type === PROFILE_TYPES.SUPERVISOR) {
    subdomain = 'supervisor';
  } else if (tenant.attributes.tenantable_type === RECORD_TYPE.PROJECT) {
    subdomain = tenant.attributes.subdomain;
  } else if (tenant.attributes.tenantable_type === RECORD_TYPE.CLIENT) {
    subdomain = tenant.attributes.subdomain;
  }
  return subdomain;
}

function zigguParentURL(path = '') {
  // suffix consists of TLD and possibly port (if non-default)
  const suffix = window.location.origin.split('.').pop();
  // prefix only for review env based on merge request id
  const prefix =
    import.meta.env.VITE_ENV === VITE_ENV_REVIEW && !import.meta.env.IS_LOCAL
      ? `${import.meta.env.VITE_PULL_REQUEST_VM_IDX}.`
      : '';
  return `https://${prefix}ziggu.${suffix}${path}`;
}

const ZIGGU_PARENT_URL = zigguParentURL();

const ZIGGU_API_URL = (() => `${window.location.origin}/api`)();

function zigguProfileTenantURL(profile, tenant) {
  const subdomain = zigguProfileSubdomain(profile, tenant);
  return profile.type === PROFILE_TYPES.CUSTOMER || profile.type === PROFILE_TYPES.SUPERVISOR
    ? zigguSubdomainURL(subdomain)
    : zigguParentURL(`/${profile.type.toLowerCase()}/${subdomain}`);
}

export {
  ZIGGU_API_URL,
  ZIGGU_PARENT_URL,
  zigguSubdomainURL,
  zigguParentURL,
  zigguProfileSubdomain,
  zigguProfileTenantURL,
};
